import { format } from 'date-fns';

export function formatDate(date, dateFormat = 'yyyy-MM-dd') {
  if (!date) {
    return '';
  }
  const d = typeof date === 'string' ? new Date(date) : date;
  return format(d, dateFormat);
}
